import React from 'react';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';

function MapaDesembarque(props) {
    let { latitudeDestino, longitudeDestino } = props.passagem;
    latitudeDestino = Number(latitudeDestino)
    longitudeDestino = Number(longitudeDestino)
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: 'AIzaSyCX5wkdWCROf0nxL2Zbh0knUdCVvtYsyEI'
    });

    const getZoom = () => {
        if (latitudeDestino && longitudeDestino) {
            return 18;
        }
        return 5;
    };

    return (
        <div className="form-row">
            <div>
                <div className="col-12">
                    {isLoaded && (
                        <GoogleMap
                            center={{ lat: latitudeDestino, lng: longitudeDestino }}
                            zoom={getZoom()}
                            mapContainerClassName="renderMapa"
                            options={{
                                disableDefaultUI: true,
                                zoomControl: true,
                                fullscreenControl: true,
                                streetViewControl: true,
                            }}
                        >
                            <Marker
                                key={'desembarque'}
                                position={{ lat: latitudeDestino, lng: longitudeDestino }}
                            />
                        </GoogleMap>
                    )}
                </div>
            </div>
        </div>
    );
}

export { MapaDesembarque };